(function (Drupal) {
  Drupal.behaviors.searchBlockForm = {
    attach: function (context, settings) {
      const searchBlockForm = document.querySelector("#search-block-form", context);

      if (searchBlockForm == null) return;

      let exitClass = document.querySelector("#trigger-class-btn");

      // Asegúrate de crear el botón solo si no existe
      if (!exitClass) {
        const triggerClassBtn = document.createElement("button");
        triggerClassBtn.id = "trigger-class-btn";
        triggerClassBtn.type = "button";
        triggerClassBtn.className = "btn btn-primary";
        triggerClassBtn.textContent = "See form";
        searchBlockForm.appendChild(triggerClassBtn);

        // Agrega el evento click para mostrar el formulario
        triggerClassBtn.addEventListener("click", function () {
          searchBlockForm.classList.add("view-input");
        });
      }

      // Elementos del DOM
      const elements = {
        navbarMain: document.querySelector("#navbar-main"),
        navbarBrand: document.querySelector(".navbar-brand"),
        blockSearch: document.querySelector("#block-subtheme-keralty-formulariodebusqueda"),
        search: document.querySelector("#block-subtheme-keralty-formulariodebusqueda .form-type-search"),
        triggerClassBtn: document.getElementById("trigger-class-btn"),
        searchActions: document.querySelector("#edit-actions"),
        searchKeys: document.querySelector(".form-search"),
      };

      // Constantes
      const MOBILE_BREAKPOINT = 992;
      const isMobileScreen = window.innerWidth < MOBILE_BREAKPOINT;

      // Funciones
      function showSearch() {
        elements.triggerClassBtn.style.display = "none";
        elements.searchActions.style.display = "block";
        elements.searchKeys.style.display = "block";

        // Ajustar la altura del encabezado
        elements.navbarMain.style.height = "160px";
        elements.navbarMain.style.paddingBottom = "9rem";
        elements.blockSearch.classList.add("responsive-search");

        // Ajustar el ancho del buscador
        const widthNavbarMain = elements.navbarMain.getBoundingClientRect().width;
        elements.search.style.width = `${widthNavbarMain - 36}px`;

        createCloseButton();
      }

      function hideSearch() {
        elements.triggerClassBtn.style.display = "block";
        elements.searchActions.style.display = "none";
        elements.searchKeys.style.display = "none";
        elements.navbarMain.style.height = "9rem";
        elements.navbarMain.style.paddingBottom = "10px";
        elements.blockSearch.classList.remove("responsive-search");
        document.getElementById("btn-close-search").remove();
      }

      function createCloseButton() {
        if (!document.getElementById("btn-close-search")) {
          const newButton = document.createElement("button");
          newButton.textContent = "Ocultar buscador mb";
          newButton.classList.add("btn", "btn-primary");
          newButton.id = "btn-close-search";
          elements.navbarBrand.insertAdjacentElement("afterend", newButton);
          newButton.addEventListener("click", hideSearch);
        }
      }

      // Escuchadores de eventos
      elements.triggerClassBtn.addEventListener("click", function (event) {
        if (elements.blockSearch && isMobileScreen) {
          showSearch();
        }
      });
    },
  };
})(Drupal);
